import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { Discount } from 'src/features/discounts/utils/types';

const RESOURCE = '/discounts/discount/:discountId/';

type QueryFnType = typeof queryFn;

interface DTO {
    discountId: string;
}
const queryFn = ({ discountId }: DTO): Promise<Discount> => {
    return axios.get(formatResourcePath(RESOURCE, { discountId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetDiscount, RESOURCE as DISCOUNT_RESOURCE };
